import React, { useContext } from 'react';
import { defineMessages } from 'react-intl';
import { SITECODE } from '@match/app-rules-resolver';
import { SiteDataContext } from 'App';
import DefaultGreeting from './DefaultGreeting';
import SC3Greeting from './SC3Greeting';

interface GreetingProps {
  handle?: string;
}

const Greeting: React.FunctionComponent<GreetingProps> = ({ handle }) => {
  const { siteCode } = useContext(SiteDataContext);
  const isJapan = siteCode === SITECODE.JAPAN;

  return (
    <React.Fragment>
      {isJapan ? <SC3Greeting /> : <DefaultGreeting handle={handle} />}
    </React.Fragment>
  );
};

export default Greeting;

export const messages = defineMessages({
  salutation: {
    id: 'src/modules/components/Greeting/Greeting:salutation',
    description: 'greeting text',
    defaultMessage: 'Hi',
  },
  howCanWeHelp: {
    id: 'src/modules/components/Greeting/Greeting:howCanWeHelp',
    description: 'how can we help text',
    defaultMessage: 'how can we help?',
  },
});
